import script from "./meetingRome.vue?vue&type=script&setup=true&lang=ts"
export * from "./meetingRome.vue?vue&type=script&setup=true&lang=ts"

import "./meetingRome.vue?vue&type=style&index=0&id=04708c2d&scoped=true&lang=scss"

import exportComponent from "/Users/zhangjun/Desktop/project/envo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04708c2d"]])

export default __exports__